module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-regular-400.woff?f5c3ba7919c746a90974c94d90e502e1";